import React from 'react';
import styles from '../styles.module.css';

type ProgressLabelProps = {
  progressLabel: {
    status: string;
    color: string;
  };
};

export default function ProgressLabel({ progressLabel }: ProgressLabelProps) {
  return (
    <div className={styles.progressLabelContainer}>
      <div
        className={styles.progressLabelBullet}
        style={{ backgroundColor: progressLabel.color }}
      />
      <span className={styles.progressLabelText}>{progressLabel.status}</span>
    </div>
  );
}
